import { useState } from "react"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"
import { Textarea } from "./ui/textarea"
import { AlertCircle, MessageSquare, Phone } from "lucide-react"
 
const SupportScreen = () => {
  const [issueType, setIssueType] = useState("")
  const [description, setDescription] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
 
  const handleSubmit = (e) => {
    e.preventDefault()
    setIsSubmitting(true)
 
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false)
      setSubmitted(true)
    }, 1500)
  }
 
  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="relative h-[100px] w-[100px] mr-3">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Help & Support</h1>
        </div>
      </div>
 
      {submitted ? (
        <Card className="border-gray-200">
          <CardContent className="pt-6 pb-6 text-center">
            <div className="flex flex-col items-center">
              <div className="rounded-full bg-green-100 p-3 mb-4">
                <MessageSquare className="h-8 w-8 text-green-600" />
              </div>
              <h2 className="text-xl font-bold mb-2 text-gray-800">Issue Reported</h2>
              <p className="text-gray-500 mb-6">
                Thank you for reporting the issue. Our support team will get back to you shortly.
              </p>
              <Button onClick={() => setSubmitted(false)} className="w-full bg-pranaam-red hover:bg-red-700 text-white">
                Report Another Issue
              </Button>
            </div>
          </CardContent>
        </Card>
      ) : (
        <>
          <Card className="mb-6 border-gray-200">
            <CardHeader className="pb-2">
              <CardTitle className="text-lg text-gray-800 text-left">Contact Support</CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="divide-y divide-gray-200">
                <div className="flex items-center justify-between p-4">
                  <div className="flex items-center">
                    <Phone className="h-5 w-5 text-gray-500 mr-3" />
                    <div className="text-left">
                      <div className="font-medium text-gray-800">Helpdesk</div>
                      <div className="text-sm text-gray-500">+91 99660 60000</div>
                    </div>
                  </div>
                  <a href="tel:919966060000">
                    <Button variant="outline" size="sm" className="border-gray-200 hover:bg-gray-50 text-gray-800">
                      Call
                    </Button>
                  </a>
                </div>
 
                <div className="flex items-center justify-between p-4">
                  <div className="flex items-center">
                    <MessageSquare className="h-5 w-5 text-gray-500 mr-3" />
                    <div className="text-left">
                      <div className="font-medium text-gray-800">Email Support</div>
                      <div className="text-sm text-gray-500">info@pranaamhospitals.in</div>
                    </div>
                  </div>
                  <a
                    href="mailto:info@pranaamhospitals.in?subject=Support%20Request&body=Please%20describe%20your%20issue%20here..."
                    className="inline-block"
                  >
                    <Button
                      variant="outline"
                      size="sm"
                      className="border-gray-200 hover:bg-gray-50 text-gray-800"
                    >
                      Email
                    </Button>
                  </a>
 
                </div>
              </div>
            </CardContent>
          </Card>
 
          {/* <Card className="border-gray-200">
            <CardHeader className="pb-2">
              <CardTitle className="text-lg text-gray-800 text-left">Report an Issue</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2 text-left">
                  <Label htmlFor="issue-type">Issue Type</Label>
                  <Select value={issueType} onValueChange={setIssueType} required>
                    <SelectTrigger id="issue-type" className="border-gray-200 text-gray-800">
                      <SelectValue placeholder="Select issue type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="app">App Issue</SelectItem>
                      <SelectItem value="appointment">Appointment Issue</SelectItem>
                      <SelectItem value="collection">Collection Issue</SelectItem>
                      <SelectItem value="account">Account Issue</SelectItem>
                      <SelectItem value="other">Other</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
 
                <div className="space-y-2 text-left">
                  <Label htmlFor="description">Description</Label>
                  <Textarea
                    id="description"
                    placeholder="Please describe the issue in detail..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="min-h-[120px] border-gray-200 text-gray-800 placeholder:text-gray-400"
                    required
                  />
                </div>
 
                <div className="space-y-2 text-left">
                  <Label htmlFor="attachment">Attachment (Optional)</Label>
                  <Input id="attachment" type="file" className="border-gray-200 text-gray-800" />
                </div>
 
                <Button
                  type="submit"
                  className="w-full h-12 bg-pranaam-red hover:bg-red-700 text-white"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit Issue"}
                </Button>
              </form>
            </CardContent>
          </Card> */}
        </>
      )}
 
      <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-100 flex">
        <AlertCircle className="h-5 w-5 text-pranaam-red mr-3 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-gray-800">
          <p className="font-medium mb-1">Need immediate assistance?</p>
          <p>Call our 24/7 helpdesk at +91 99660 60000 for urgent issues.</p>
        </div>
      </div>
    </AppLayout>
  )
}
 
export default SupportScreen